export default "__VITE_ASSET__a25cf4d5__"